/**
 * Normalize icon values from grid metadata (Umbraco faIcon picker → string class names).
 */
export function normalizeCommandIcon(icon: unknown): string | null {
  if (icon == null) return null;

  if (typeof icon === 'string') {
    const trimmed = icon.trim();
    return trimmed || null;
  }

  if (typeof icon === 'object') {
    const record = icon as Record<string, unknown>;
    const nested = record.icon ?? record.Icon ?? record.className ?? record.ClassName;
    if (typeof nested === 'string') {
      const trimmed = nested.trim();
      return trimmed || null;
    }
  }

  const asString = String(icon).trim();
  if (!asString || asString === '[object Object]') return null;
  return asString;
}
